export interface DiscountAtCheckout {
  id: number;
  name: string;
  price: number;
}

export const discountAtCheckoutFromResponse = (
  responseData: any,
): DiscountAtCheckout => ({
  id: responseData.id,
  name: responseData.name,
  price: responseData.price / 100,
});

export const discountAtCheckoutToUpsertRequest = (
  discountAtCheckout: DiscountAtCheckout,
) => ({
  id: discountAtCheckout.id,
  price: Math.round(discountAtCheckout.price * 100),
});
